<p-button
    [type]="isFormSubmitButton ? 'submit' : 'button'"
    [label]="label | translate"
    [icon]="icon"
    [iconPos]="iconPos"
    [loading]="loading"
    [disabled]="isDisabled"
    [style]="style"
    [class]="class"
    [styleClass]="styleClass"
    [pTooltip]="tooltip | translate"
    tooltipPosition="top"
    (onClick)="emitButtonClick($event)"
    (onBlur)="emitButtonBlur($event)"
    (onFocus)="emitButtonFocus($event)"></p-button>
<ng-content select="sera-items-count"></ng-content>
